import * as React from "react"
const Sword = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={24}
    height={24}
    transform="rotate(270)"
    viewBox="0 0 511.989 511.989"
    {...props}
  >
    <path
      d="M48.641 496.629c-2.726 0-5.46-1.031-7.539-3.123L18.47 470.881c-2-2-3.125-4.703-3.125-7.531s1.125-5.547 3.125-7.547l79.194-79.201a10.662 10.662 0 0 1 15.085 0l22.625 22.623a10.668 10.668 0 0 1 0 15.096l-79.193 79.186a10.59 10.59 0 0 1-7.54 3.122z"
      style={{
        fill: "#965353",
      }}
    />
    <path
      d="M63.727 448.256c-7.055-7.047-16.429-10.938-26.398-10.938-9.976 0-19.351 3.891-26.398 10.938-14.554 14.562-14.554 38.25 0 52.795 7.047 7.047 16.422 10.938 26.398 10.938 9.969 0 19.344-3.891 26.398-10.938 14.555-14.545 14.555-38.233 0-52.795z"
      style={{
        fill: "#ffce54",
      }}
    />
    <path
      d="m59.954 414.32 37.71 37.701 15.085-15.078-37.71-37.719z"
      style={{
        fill: "#7f4545",
      }}
    />
    <path
      d="M309.323 362.664c0 5.891-4.781 10.656-10.672 10.656s-10.672-4.766-10.672-10.656 4.781-10.672 10.672-10.672 10.672 4.781 10.672 10.672z"
      style={{
        fill: "#48cfad",
      }}
    />
    <path
      d="M74.657 213.324c0 5.891-4.773 10.672-10.664 10.672s-10.664-4.781-10.664-10.672 4.773-10.656 10.664-10.656c5.89-.001 10.664 4.765 10.664 10.656z"
      style={{
        fill: "#5d9cec",
      }}
    />
    <path
      d="M501.319 191.996c0 5.89-4.781 10.671-10.672 10.671s-10.671-4.781-10.671-10.671c0-5.891 4.78-10.672 10.671-10.672s10.672 4.781 10.672 10.672z"
      style={{
        fill: "#a0d468",
      }}
    />
    <path
      d="M95.992 63.999c0 5.891-4.773 10.671-10.664 10.671s-10.672-4.781-10.672-10.671 4.781-10.672 10.672-10.672c5.891 0 10.664 4.781 10.664 10.672z"
      style={{
        fill: "#ac92eb",
      }}
    />
    <path
      d="M266.66 42.671c0 5.89-4.781 10.656-10.671 10.656-5.891 0-10.665-4.766-10.665-10.656 0-5.891 4.773-10.672 10.665-10.672 5.89 0 10.671 4.781 10.671 10.672z"
      style={{
        fill: "#ed5564",
      }}
    />
    <path
      d="M373.321 469.318c0 5.891-4.781 10.672-10.672 10.672s-10.672-4.781-10.672-10.672 4.781-10.656 10.672-10.656 10.672 4.766 10.672 10.656z"
      style={{
        fill: "#ffce54",
      }}
    />
    <path
      d="M447.976 319.992V309.32c0-5.891-4.766-10.654-10.656-10.654s-10.671 4.764-10.671 10.654v10.672c-5.891 0-10.672 4.781-10.672 10.672s4.781 10.656 10.672 10.656v10.672c0 5.891 4.78 10.672 10.671 10.672s10.656-4.781 10.656-10.672V341.32c5.891 0 10.672-4.766 10.672-10.656s-4.781-10.672-10.672-10.672z"
      style={{
        fill: "#5d9cec",
      }}
    />
    <path
      d="M191.99 149.325v-10.656c0-5.891-4.773-10.672-10.664-10.672s-10.672 4.781-10.672 10.672v10.656c-5.891 0-10.664 4.781-10.664 10.671 0 5.891 4.773 10.672 10.664 10.672v10.656c0 5.891 4.781 10.672 10.672 10.672s10.664-4.781 10.664-10.672v-10.656c5.891 0 10.664-4.781 10.664-10.672 0-5.89-4.773-10.671-10.664-10.671z"
      style={{
        fill: "#fc6e51",
      }}
    />
    <path
      d="M501.319 21.327V10.671c0-5.89-4.781-10.671-10.672-10.671s-10.671 4.781-10.671 10.671v10.656c-5.891 0-10.656 4.781-10.656 10.672s4.766 10.672 10.656 10.672v10.656c0 5.891 4.78 10.672 10.671 10.672s10.672-4.781 10.672-10.672V42.671c5.89 0 10.655-4.781 10.655-10.672s-4.765-10.672-10.655-10.672z"
      style={{
        fill: "#48cfad",
      }}
    />
    <path
      d="M161.779 406.131a10.666 10.666 0 0 1-7.546-3.125l-45.249-45.264c-2.008-2-3.125-4.703-3.125-7.531s1.117-5.547 3.125-7.547L355.649 95.998a10.7 10.7 0 0 1 6.031-3.016l52.797-7.547c3.328-.469 6.672.641 9.047 3.016s3.499 5.734 3.016 9.062l-7.547 52.795a10.55 10.55 0 0 1-3.016 6.031L169.318 403.006c-2 2-4.711 3.125-7.539 3.125z"
      style={{
        fill: "#ffce54",
      }}
    />
    <path
      d="M139.147 383.506a10.65 10.65 0 0 1-7.539-3.123c-4.164-4.172-4.164-10.922 0-15.094l186.324-186.324c4.172-4.172 10.922-4.172 15.077 0 4.172 4.157 4.172 10.922 0 15.078l-186.316 186.34a10.664 10.664 0 0 1-7.546 3.123z"
      style={{
        fill: "#f6bb42",
      }}
    />
    <path
      d="M199.49 418.086 93.898 312.492a10.69 10.69 0 0 0-9.257-2.984 10.635 10.635 0 0 0-7.828 5.766L61.728 345.43a10.654 10.654 0 0 0 2 12.312l90.505 90.514a10.671 10.671 0 0 0 7.546 3.125c1.617 0 3.25-.359 4.766-1.125l30.172-15.078a10.677 10.677 0 0 0 2.773-17.092z"
      style={{
        fill: "#ed5564",
      }}
    />
  </svg>
)
export default Sword
